import axios from "axios";
import vue from "../main";
import Cookie from "js-cookie";
import { GetAuthToken } from "rj-server-auth-token";
import {
  handleAxiosAndRouterToken,
  PARTNERS_TOKEN,
  removeAllCookie,
  toLogin
} from "../utils/loginUtils";
import { handleComplianceResponse } from "../utils/compliance";
// 接口白名单
const whiteList = ["/partners-center-admin/userAuthority/token/generate"];
// 不再限制到一个服务
const Api = axios.create({
  baseURL: window._env_.BASE_APIS,
  withCredentials: true,
  headers: {
    sysId: "be7b21f00c034675a75a270257275f24"
  }
});
export { Api };
// http请求拦截
Api.interceptors.request.use(
  async config => {
    // 当前语言环境（zh/en），后端合规检测按此返回对应语言的提示文案
    config.headers["Accept-Language"] = Cookie.get("language") || "en";
    // 请求白名单
    if (!whiteList.includes(config.url)) {
      await handleAxiosAndRouterToken();
      // 这个地方的时候必有token
      config.headers["token"] = Cookie.get(PARTNERS_TOKEN);
    }

    config.headers["web-sign-server-auth"] = GetAuthToken({
      sysId: "be7b21f00c034675a75a270257275f24",
      accessKeySecret: "9174A3DE0A8940E2B1741324FBA75339"
    });

    if (config.method === "get") {
      config.params = {
        ...config.params,
        _t: Date.parse(new Date()) / 1000
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http响应拦截器
Api.interceptors.response.use(
  res => {
    switch (res.data.status) {
      case "200":
        handleComplianceResponse(res.data);
        break;
      case "10001":
        vue.$notify({
          message: vue.$createElement(
            "div",
            res.data.err
              .split(/\n/)
              .map(item => vue.$createElement("div", item))
          ),
          type: "error"
        });
        break;
      case "403":
        removeAllCookie();
        toLogin();
        break;
      case "88888":
        if (window._env_.ENV === "pro") {
          window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        } else {
          window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        }
        break;
      default:
        if (res.data.err) {
          vue.$notify({
            title: res.data.err,
            type: "error"
          });
        }
    }
    return res.data;
  },
  async error => {
    if (error && error.isComplianceBlock) {
      return Promise.reject(error);
    }
    if (error.response && error.response.status === 403) {
      removeAllCookie();
      toLogin();
    } else if (error.response) {
      vue.$notify.error(error.response.data.err);
    } else {
      vue.$notify.error("系统异常");
    }
  }
);

// 用cookies获取token
export const postGenerate = params =>
  Api.post(`/partners-center-admin/userAuthority/token/generate`, params);

// 清除token的状态等于这个Token在后端校验服务中直接失效
export const cleanToken = token =>
  Api.get(`/partners-center-admin/userAuthority/token/cleanToken`, {
    params: { token }
  });

/**
 * 计算当前任务量
 * @see https://yapi.ruijie.com.cn/project/1374/interface/api/109533
 */
export const getCalculateTarget = params =>
  Api.post(
    "/partners-product-service/customerTaskAssessment/getCalculateTarget",
    params
  );

// 获取全部的渠道类型
export const getAllPartnerTypes = () =>
  Api.get("/partners-customer-service/partnerTypes/getAllPartnerTypes");

// 获取特定的的渠道类型
export const getPartnerType = (partnerType, rcpFlag) =>
  Api.get("/partners-customer-service/contract/getPartnerType", {
    params: { partnerType, rcpFlag }
  });
export const getRenewPartnerType = documentId =>
  Api.get(
    `/partners-customer-service/contract25/getRenewPartnerType?documentId=${documentId}`
  );

// 根据国家代码搜索VadAndSubs
export const searchVadAndSubs = countryCode =>
  Api.get("/partners-customer-service/partner/vadAndSubs", {
    params: { countryCode, companyName: '' }
  });

// 获取全部国家
export const getAllCountries = () =>
  Api.get("/partners-customer-service/area/getAllCountries");

// 搜索vad
export const getVadList = params =>
  Api.get("/partners-customer-service/partner/getvads", {
    params
  });
// EBG获取上级渠道
export const getEBGAffiliatedist = params =>
  Api.get("/partners-customer-service/partner/getEBGAffiliated", {
    params
  });

// 搜索客户
export const searchCustomer = keyword =>
  Api.get(`/partners-customer-service/customer/search`, {
    params: { keyword }
  });
// 下载模板
export const getFileBySingType = params =>
  Api.post(`/partners-customer-service/common/getFileBySignType`, params);
// 上传附件信息
export const postOssUpload = params =>
  Api.post(`/partners-customer-service/common/ossUpload`, params);
/**
 * 校验主账号状态
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109493
 */
export const verifyMainAccount = mainAccount =>
  Api.post("/partners-customer-service/contract/verifyMainAccount", null, {
    params: { mainAccount }
  });

/**
 * 创建签约 SBG
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/111585
 */
export const createPartner = params =>
  Api.post("/partners-customer-service/contract/createContractSBG", params);

/**
 * 获取签约详情
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109738
 */
export const getContractDetails = documentId =>
  Api.post("/partners-customer-service/contract/getContractDetails", null, {
    params: { documentId },
    headers: {
      languageKey: "en"
    }
  });

/**
 * 签约审批
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109498
 */
export const approvalProcess = params =>
  Api.post("/partners-customer-service/contract/approvalProcess", params);

/**
 * 获取待审批列表
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109503
 */
export const getPendingApprovalList = params =>
  Api.post(
    "/partners-customer-service/contract/getPendingApprovalList",
    params
  );

/**
 * 获取节点类型
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109983
 */
export const getNodeType = () =>
  Api.get("/partners-customer-service/contract/getNodeType");

/**
 * 签约续签
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109743
 */
export const renewContract = params =>
  Api.post("/partners-customer-service/contract/renew", params);

/**
 * 签约续签
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109743
 */
export const renewContract25 = params =>
  Api.post("/partners-customer-service/contract25/renewSbg", params);

/**
 * 获取合同列表
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109978
 */
export const getContractList = params =>
  Api.post("/partners-customer-service/contract/getContractList", params);

/**
 * 获取合同列表
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109978
 */
export const getCurrencyContractList = params =>
  Api.post(
    "/partners-customer-service/currency/contract/getContractList",
    params
  );

/**
 * 编辑合同
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109918
 */
export const editContract = (params, cancel) =>
  Api.post("/partners-customer-service/contract/edit", params, {
    cancelToken: new axios.CancelToken(function executor(c) {
      // 这个 executor 函数接收一个 cancel 函数作为参数
      cancel && cancel(c);
    })
  });

/**
 * 编辑合同 2025
 */
export const editContract25 = (params, cancel) =>
  Api.post("/partners-customer-service/contract25/edit", params, {
    cancelToken: new axios.CancelToken(function executor(c) {
      // 这个 executor 函数接收一个 cancel 函数作为参数
      cancel && cancel(c);
    })
  });

/**
 * 重新提交合同
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109923
 */
export const editRejectionContract = params =>
  Api.post("/partners-customer-service/contract/editRejection", params);

/**
 * 获取合同状态是否已经结束
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/111109
 */
export const getEndFlowState = documentId =>
  Api.get("/partners-customer-service/contract/getEndFlowState", {
    params: {
      documentId
    }
  });
/**
 * 获取合同状态是否已经结束2025
 */
export const getEndFlowState25 = documentId =>
  Api.get("/partners-customer-service/contract25/getEndFlowState", {
    params: {
      documentId
    }
  });

/**
 * 旧数据获取详情
 * todo 缺少api文档
 */
export const getOldRenewDetail = documentId =>
  Api.get("/partners-customer-service/contract/oldRenewDetail", {
    params: {
      documentId
    }
  });

/**
 * 旧数据获取详情
 * todo 缺少api文档
 */
export const getCurrencyOldRenewDetail = documentId =>
  Api.get("/partners-customer-service/currency/contract/oldRenewDetail", {
    params: {
      documentId
    }
  });

/**
 * 获取smb的授权牌
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109933
 */
export const getByObjectIdAndType = params =>
  Api.get("/partners-customer-service/attachment/getByObjectIdAndType", {
    params
  });

/**
 * 获取菜单
 */
export const getSignMenu = params =>
  Api.post(
    "/partners-center-admin/account/accounts/get-sign-left-menus",
    params
  ); //获取菜单-新接口

/**
 * 创建签约 创建签约 EBG企业网/CBG互联网/TBU运营商
 * @param params
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/111641
 */
export const createContractEBGorCBGorTBU = params =>
  Api.post(
    "/partners-customer-service/contract/createContractEBGorCBGorTBU",
    params
  );

/**
 * 获取签约配置
 * @param name
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/111606
 */
export const findListByName = name =>
  Api.get("/partners-customer-service/sysBaseConfig/findListByName", {
    params: { name }
  });

/**
 * 关联人员修改流程节点
 * @param {object} params
 * @param {string} params.documentId 签约Id
 * @param {string} params.node 节点
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/111599
 */
export const managementPersonnelModifyProcessNodes = params =>
  Api.post(
    "/partners-customer-service/contract/managementPersonnelModifyProcessNodes",
    null,
    {
      params
    }
  );
/**
 * 获取签约合同的审批节点
 * @param {string} documentId 签约Id
 */
export const getProcessNodes = documentId =>
  Api.get("/partners-customer-service/contract/getProcessNodes", {
    params: { documentId }
  });

/**
 * 高级编辑
 * @param params
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/111550
 */
export const editAdvanced = params =>
  Api.post("/partners-customer-service/contract/editAdvanced", params);

/**
 * 高级编辑
 * @param params
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/111550
 */
export const editAdvanced25 = params =>
  Api.post("/partners-customer-service/contract25/editAdvanced", params);

/**
 * excelSelfContracts 非管理员导出
 * @param params
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/112077
 */
export const excelSelfContracts = params =>
  Api.post("/partners-customer-service/partner/exportBySelf", params, {
    responseType: "blob"
  });

/**
 * excelSelfContracts 管理员导出
 * @param params
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/112078
 */
export const excelAdminContracts = params =>
  Api.post("/partners-customer-service/partner/exportByAdmin", params, {
    responseType: "blob"
  });
/**
 *
 * https://www.ruijienetworks.com/api/auth/webuser
 */
export const getWebuser = params =>
  Api.post(
    `https://www.ruijienetworks.com/api/auth/webuser?data=${params}`,
    params
  );
/**
 *
 * 获取渠道类型首页按钮显示
 */
export const getInsideUserChannelInfo = params =>
  Api.post("/partners-customer-service/api/v1/insideUserChannelInfo", params);

/**
 * CancelProcess 管理员废弃高级编辑
 * @param params
 * @param {string} params.documentId 签约Id
 * @param {string} params.workflowId 签约流程Id
 * 文档缺失
 * 由石均棠开发
 */
export const cancelSeniorProcess = params =>
  Api.get("/partners-customer-service/contract/CancelProcess", { params });

/**
 * 更改销售
 * @param params
 * 文档缺失
 * 由石均棠开发
 */
export const changeSales = params =>
  Api.post("/partners-customer-service/contract/changeSales", params);

/**
 * 获取用户信息
 * @param userId
 */
export const userChannelInfoByUserId = userId =>
  Api.post("/partners-customer-service/api/v1/userChannelInfoByUserId", null, {
    params: { userId }
  });

/**
 * 获取用户信息
 */
export const insertChannelBurial = params =>
  Api.post(`/partners-center-admin/ChannelBurial/insertChannelBurial`, params);

export const getProductLineAuthorization = params =>
  Api.get("/partners-order-service/product/getProductLineAuthorization");

/**
 * 获取渠道等级
 * @param partnerType
 */
export const getPartnerLevelByType = partnerType =>
  Api.get("/partners-customer-service/contract25/getPartnerLevelByType", {
    params: { partnerType }
  });

/**
 * 获取渠道等级
 * @param params
 */
export const getPartInSpecConfig = params =>
  Api.post("/partners-customer-service/contract25/getPartInSpecConfig", params);

/**
 * 计算当前任务量2025
 */
export const getCalculateTarget25 = params =>
  Api.post(
    "/partners-product-service/customerTaskAssessment/getCalculateTarget25",
    params
  );

/**
 * 创建签约 SBG2025
 */
export const createPartner25 = params =>
  Api.post("/partners-customer-service/contract25/createContractSBG", params);

/**
 * 创建签约 SBG2025
 */
export const getContractDetails25 = documentId =>
  Api.post("/partners-customer-service/contract25/getContractDetails", null, {
    params: { documentId }
  });

/**
 * 创建签约 SBG2025(脱敏)
 * @param {*} params
 * @returns
 */
export const getCurrencyContract25Details = documentId =>
  Api.post(
    `/partners-customer-service/currency/contract25/getContractDetails?documentId=${documentId}`
  );

/**
 * 创建签约 SBG2025(脱敏)
 * @param {*} params
 * @returns
 */
export const getCurrencyContractDetails = documentId =>
  Api.post(
    `/partners-customer-service/currency/contract/getContractDetails?documentId=${documentId}`
  );

/**
 * 获取子账号 SBG2025
 */
export const getAccountByMasterNotReject = (masterAccount, partnerType) =>
  Api.get("/partners-customer-service/account/getAccountByMasterNotReject", {
    params: { masterAccount, pageNum: 1, pageSize: 1000, state: 1, partnerType }
  });
export const getAccountByMasterNotRejectCurrency = (
  masterAccount,
  partnerType
) =>
  Api.get(
    "/partners-customer-service/currency/account/getAccountByMasterNotReject",
    {
      params: {
        masterAccount,
        pageNum: 1,
        pageSize: 1000,
        state: 1,
        partnerType
      }
    }
  );

/**
 * 翻译
 */
export const getWordTranslationList = params =>
  Api.post("/partners-center-admin/api/getWordTranslationList", params);

/**
 * 签约审批 2025
 */
export const approvalProcess25 = params =>
  Api.post("/partners-customer-service/contract25/approvalProcess", params);

/**
 * 重新提交合同
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109923
 */
export const editRejectionContract25 = params =>
  Api.post("/partners-customer-service/contract25/editRejection", params);

/**
 * 重新提交合同
 * @see https://yapi.ruijie.com.cn/project/1297/interface/api/109923
 */
export const editRejectionContract26 = params =>
  Api.post("/partners-customer-service/contract26/editRejection", params);

/**
 * 检验改合同是否存在相同类型的渠道
 */
export const checkRenewType = params =>
  Api.post("/partners-customer-service/contract25/checkRenewType", params);

/**
 * 获取细分市场
 */
export const getMarketSegmentation = () =>
  Api.get("/partners-customer-service/contract25/getMarketSegmentation");

/**
 * 获取渠道主营行业
 */
export const getChannelMainIndustry = () =>
  Api.get("/partners-customer-service/contract25/getChannelMainIndustry");


/**
 * 获取代理品牌
 */
export const getMainChannelBrands = () => Api.get("/partners-customer-service/contract25/getMainChannelBrands");

/**
 * 代理的主要品类
 */
export const getMainProductCategories = () =>
  Api.get("/partners-customer-service/contract25/getMainProductCategories");



// WEBPACK FOOTER //
// ./src/api/international.js